// This is a skeleton starter React page generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {PageParamsProvider as PageParamsProvider__} from "@plasmicapp/react-web/lib/host";
import GlobalContextsProvider from "../components/plasmic/nebank/PlasmicGlobalContextsProvider";

import {SegmentContextProvider} from "../components/plasmic/nebank/PlasmicGlobalVariant__Segment";
import {PlasmicGdpr} from "../components/plasmic/nebank/PlasmicGdpr";
import {useRouter} from "next/router";
import {PlasmicQueryDataProvider} from "@plasmicapp/react-web/lib/query";
import {CommonPageProps, handleStaticPageRequest} from "@lg-plus/landing-components";
import PlasmicSplitsProvider from "../components/plasmic/nebank/PlasmicSplitsProvider";

export const getServerSideProps = handleStaticPageRequest;

function Gdpr({traits}: CommonPageProps) {
    // Use PlasmicGdpr to render this component as it was
    // designed in Plasmic, by activating the appropriate variants,
    // attaching the appropriate event handlers, etc.  You
    // can also install whatever React hooks you need here to manage state or
    // fetch data.
    //
    // Props you can pass into PlasmicGdpr are:
    // 1. Variants you want to activate,
    // 2. Contents for slots you want to fill,
    // 3. Overrides for any named node in the component to attach behavior and data,
    // 4. Props to set on the root node.
    //
    // By default, PlasmicGdpr is wrapped by your project's global
    // variant context providers. These wrappers may be moved to
    // Next.js Custom App component
    // (https://nextjs.org/docs/advanced-features/custom-app).

    return (
        <SegmentContextProvider value={undefined}>
            <GlobalContextsProvider>
                <PlasmicQueryDataProvider>
                    <PageParamsProvider__
                        route={useRouter()?.pathname}
                        params={useRouter()?.query}
                        query={useRouter()?.query}
                    >
                        <PlasmicSplitsProvider traits={traits}>
                            <PlasmicGdpr />
                        </PlasmicSplitsProvider>
                    </PageParamsProvider__>
                </PlasmicQueryDataProvider>
            </GlobalContextsProvider>
        </SegmentContextProvider>
    );
}

export default Gdpr;
